/**
 * Shared background + text color class map.
 *
 * Every section uses the same ten-value backgroundStyle enum.
 * Importing from here avoids duplicating the record in each component.
 */
export const bgClasses: Record<string, string> = {
  primary: "bg-primary text-on-primary",
  secondary: "bg-secondary text-on-secondary",
  surface: "bg-surface text-text",
  dark: "bg-accent text-white",
  brand: "bg-background text-on-brand",
  light: "bg-white text-text",
  tertiary: "bg-tertiary text-on-tertiary",
  primaryBg: "bg-primary-bg text-on-primary-bg",
  secondaryBg: "bg-secondary-bg text-on-secondary-bg",
  tertiaryBg: "bg-tertiary-bg text-on-tertiary-bg",
};
